import { create } from "zustand";

export const useNotificationStore = create((set) => ({
    notificationData: [],
    newNotification: false,
    
    setNotificationData: (item) => {
        set({
            notificationData: item
        })
    },

    setNewNotification: (item) => {
        set({
            newNotification: item
        })
    }
}));